module.exports = __webpack_public_path__ + "img/Accepts.7355483f.svg";